// Constantes e helpers compartilhados do módulo Atendimentos.

export const STATUS = {
  scheduled: {
    labelKey: 'ATENDIMENTOS.status.scheduled',
    badge: 'bg-blue-100 text-blue-800 dark:bg-blue-900/40 dark:text-blue-300',
    dot: 'bg-blue-500',
  },
  confirmed: {
    labelKey: 'ATENDIMENTOS.status.confirmed',
    badge:
      'bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-300',
    dot: 'bg-green-500',
  },
  waiting: {
    labelKey: 'ATENDIMENTOS.status.waiting',
    badge:
      'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/40 dark:text-yellow-300',
    dot: 'bg-yellow-500',
  },
  in_progress: {
    labelKey: 'ATENDIMENTOS.status.in_progress',
    badge:
      'bg-purple-100 text-purple-800 dark:bg-purple-900/40 dark:text-purple-300',
    dot: 'bg-purple-500',
  },
  completed: {
    labelKey: 'ATENDIMENTOS.status.completed',
    badge: 'bg-gray-100 text-gray-700 dark:bg-n-solid-3 dark:text-n-slate-11',
    dot: 'bg-gray-400',
  },
  missed: {
    labelKey: 'ATENDIMENTOS.status.missed',
    badge: 'bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-300',
    dot: 'bg-red-500',
  },
  cancelled: {
    labelKey: 'ATENDIMENTOS.status.cancelled',
    badge: 'bg-gray-100 text-gray-500 dark:bg-n-solid-3 dark:text-n-slate-11',
    dot: 'bg-gray-300',
  },
};

export const PLAN_TYPES = [
  { value: 'particular', labelKey: 'ATENDIMENTOS.partners.types.particular' },
  { value: 'convenio', labelKey: 'ATENDIMENTOS.partners.types.convenio' },
  { value: 'plano', labelKey: 'ATENDIMENTOS.partners.types.plano' },
];

export const DAYS = [
  ['ATENDIMENTOS.practitioners.weekdays.dom', 0],
  ['ATENDIMENTOS.practitioners.weekdays.seg', 1],
  ['ATENDIMENTOS.practitioners.weekdays.ter', 2],
  ['ATENDIMENTOS.practitioners.weekdays.qua', 3],
  ['ATENDIMENTOS.practitioners.weekdays.qui', 4],
  ['ATENDIMENTOS.practitioners.weekdays.sex', 5],
  ['ATENDIMENTOS.practitioners.weekdays.sab', 6],
];

// Ícones (paths SVG outline, viewBox 0 0 24 24) — evita emojis, igual ao original.
export const ICON = {
  calendar: [
    'M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z',
  ],
  clock: ['M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z'],
  users: [
    'M17 20h5v-2a4 4 0 00-3-3.87M9 20H4v-2a4 4 0 013-3.87m9-4a4 4 0 10-8 0 4 4 0 008 0z',
  ],
  briefcase: [
    'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2',
  ],
  shield: [
    'M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z',
  ],
  chart: [
    'M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z',
  ],
  chevronL: ['M15 19l-7-7 7-7'],
  chevronR: ['M9 5l7 7-7 7'],
  plus: ['M12 4v16m8-8H4'],
};

export const fmtMoney = v =>
  v == null || v === ''
    ? ''
    : new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      }).format(Number(v));
export const fmtTime = iso =>
  new Date(iso).toLocaleTimeString('pt-BR', {
    hour: '2-digit',
    minute: '2-digit',
  });
export const sameDay = (a, b) => a.toDateString() === b.toDateString();
export const startOfWeek = d => {
  const x = new Date(d);
  x.setDate(x.getDate() - x.getDay());
  x.setHours(0, 0, 0, 0);
  return x;
};
